import { useSignal } from "@preact/signals";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { userSignal } from "../../../signal/userSignal";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useMutation } from "react-query";


export default function EditTransportDetails(props) {

    const [transportDetails, setTransportDetails] = useState(props?.order?.transportDetails ? props?.order?.transportDetails : {
        ewayBillNumber: "",
        docNumber: "",
        vehicleNumber: "",
        courierName: "",
        contactPersonName: "",
        contactPersonNumber: "",
        trackingLink: "",
    });

    useEffect(() => {
        if (props?.transportDetails) {
            setTransportDetails(props?.order?.transportDetails)
        }
    }, [props])

    const updateTransportDetailsMutation = useMutation((data) => axios.put(`${DEV_SERVER}/order/v2/updateTransportDetails/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal?.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data?.data
            if (data.status) {
                toast.success(data.message);
                props?.refetchOrder();
                props?.close();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const handleUpdateTransportDetails = () => {

        let data = {}

        data.id = props?.order?.id
        data.body = transportDetails

        updateTransportDetailsMutation.mutate(data)
    }

    return (
        <Modal fullscreen show={props?.show} onHide={props?.close} style={{ height: "100%", width: "100%" }}>
            <Modal.Header closeButton>
                <Modal.Title>Update Transport Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form className="d-flex flex-wrap justify-content-center align-items-center" style={{ rowGap: "1rem", columnGap: "1rem", gridTemplateColumns: "0.5fr 0.5fr" }}>
                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Eway Bill Number</Form.Label>
                        <Form.Control required={true} value={transportDetails?.ewayBillNumber} onChange={(e) => setTransportDetails({ ...transportDetails, ewayBillNumber: e.target.value })} type="text" placeholder="Enter Eway Bill Number" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Doc Number</Form.Label>
                        <Form.Control required={true} value={transportDetails?.docNumber} onChange={(e) => setTransportDetails({ ...transportDetails, docNumber: e.target.value })} type="text" placeholder="Enter Doc Number" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Vehicle Number</Form.Label>
                        <Form.Control required={true} value={transportDetails?.vehicleNumber} onChange={(e) => setTransportDetails({ ...transportDetails, vehicleNumber: e.target.value })} type="text" placeholder="Enter Vehicle Number" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Courier Name</Form.Label>
                        <Form.Control required={true} value={transportDetails?.courierName} onChange={(e) => setTransportDetails({ ...transportDetails, courierName: e.target.value })} type="text" placeholder="Enter Courier Name" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Contact Person Name</Form.Label>
                        <Form.Control required={true} value={transportDetails?.contactPersonName} onChange={(e) => setTransportDetails({ ...transportDetails, contactPersonName: e.target.value })} type="text" placeholder="Enter Contact Person Name" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Contact Person Number</Form.Label>
                        <Form.Control required={true} value={transportDetails?.contactPersonNumber} onChange={(e) => setTransportDetails({ ...transportDetails, contactPersonNumber: e.target.value })} type="text" placeholder="Enter Contact Person Number" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Tracking Link</Form.Label>
                        <Form.Control required={true} value={transportDetails?.trackingLink} onChange={(e) => setTransportDetails({ ...transportDetails, trackingLink: e.target.value })} type="text" placeholder="Enter Tracking Link" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button disabled={updateTransportDetailsMutation.isLoading} variant="primary" onClick={() => handleUpdateTransportDetails()}>
                    {(updateTransportDetailsMutation.isLoading) ? <Spinner animation="border" size="sm" /> : "Update"}
                </Button>
                <Button variant="secondary" onClick={() => props?.close()}>
                    Close
                </Button>
            </Modal.Footer>

        </Modal>
    )

}